import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const PxdbDeviceReducer: AppReducer<'PxdbDevice'> = (
    state = InitialState.PxdbDevice,
    action
): typeof state => {
    switch (action.type) {
        case 'PxdbGatewayDevice/Registration/Started':
            return {
                ...state,
                pxdbgatewayLoading: true,
                pxdbgatewaySuccess: false,
            };

        case 'PxdbGatewayDevice/Registration/Succeeded':
            return {
                ...state,
                pxdbgatewayLoading: false,
                pxdbgatewaySuccess: true,
                connectionString: action.payload.connectionString,
            };

        case 'PxdbGatewayDevice/Registration/Failed':
            return {
                ...state,
                pxdbgatewayLoading: false,
                pxdbgatewaySuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'PxdbGatewayDevice/Registration/Unmounted':
            return {
                ...state,
                pxdbgatewayLoading: false,
                pxdbgatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
            };

        default:
            return state;
    }
};
